import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  // constants for the number of milliseconds in a minute, hour, and day
  private readonly MS_IN_MINUTE: number = 1000 * 60;
  private readonly MS_IN_HOUR: number = this.MS_IN_MINUTE * 60;
  private readonly MS_IN_DAY: number = this.MS_IN_HOUR * 24;

  public transform(date: Date | string): string {
    // get the current date and the input date in milliseconds
    const now: number = new Date().getTime();
    // if the input is a string, convert it to a Date object
    const inputDate: number = (typeof date === 'string' ? new Date(date).getTime() : date.getTime());
    // calculate the difference in milliseconds
    const differenceInMs: number = now - inputDate;

    // if the difference is 1 day or more, return the number of days
    const days: number = Math.floor(differenceInMs / this.MS_IN_DAY);
    if (days >= 1) {
      return `${days} ${days === 1 ? 'dag' : 'dagen'}`;
    }

    // if the difference is 1 hour or more, return the number of hours
    const hours: number = Math.floor(differenceInMs / this.MS_IN_HOUR);
    if (hours >= 1) {
      return `${hours} uur`;
    }

    // if the difference is 1 minute or more, return the number of minutes
    const minutes: number = Math.floor(differenceInMs / this.MS_IN_MINUTE);
    if (minutes >= 1) {
      return `${minutes} ${minutes === 1 ? 'minuut' : 'minuten'}`;
    }

    // if the difference is less than a minute, return 'zojuist'
    return 'zojuist';
  }
}
